import { render } from "./ResetSettingsCard.vue?vue&type=template&id=d9766158&scoped=true"
import script from "./ResetSettingsCard.vue?vue&type=script&lang=js"
export * from "./ResetSettingsCard.vue?vue&type=script&lang=js"

import "./ResetSettingsCard.vue?vue&type=style&index=0&id=d9766158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9766158"]])

export default __exports__